import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const cccStandardsAdapter = getAdapter();

const cccStandardsSlice = createSlice({
  name: 'cccStandards',
  initialState: cccStandardsAdapter.getInitialState({
    source: null,
  }),
  reducers: {
    setcccStandards: (state, { payload: { cccStandards, source } }) => {
      cccStandardsAdapter.setAll(state, cccStandards);
      state.source = source;
    },
  },
});

const selectors = cccStandardsAdapter.getSelectors(({ cccStandards }) => cccStandards);

export const getcccStandards = (state) => selectors.selectAll(state);

export const {
  setcccStandards: setcccStandards,
} = cccStandardsSlice.actions;

export default cccStandardsSlice.reducer;